import React from 'react';
import { Box, Tooltip } from '@mui/material';

import { BPFDealStatus, ReportsListingViewModel } from '../../../types';

const DOT_COLOR: Record<BPFDealStatus, string> = {
  [BPFDealStatus.Healthy]: '#12B76A',
  [BPFDealStatus.Hot]: '#EC4899',
  [BPFDealStatus.Stalled]: '#F79009',
  [BPFDealStatus.AtRisk]: '#F04438',
};

const DOT_LABEL: Record<BPFDealStatus, string> = {
  [BPFDealStatus.Healthy]: 'Healthy — activity within last 5 days',
  [BPFDealStatus.Hot]: 'Hot — close date within 30 days, probability ≥ 50%',
  [BPFDealStatus.Stalled]: 'Stalled — no stage progression in 5–10 days',
  [BPFDealStatus.AtRisk]: 'At Risk — overdue or stuck in stage 10+ days',
};

interface Props {
  row: ReportsListingViewModel;
}

export const DealStatusDotCell = ({ row }: Props) => (
  <Box display="flex" alignItems="center" justifyContent="center" width="100%">
    <Tooltip title={DOT_LABEL[row.dealStatus]} placement="right" arrow>
      <Box
        sx={{
          width: '1rem',
          height: '1rem',
          flexShrink: 0,
          cursor: 'default',
          borderRadius: '50%',
          backgroundColor: DOT_COLOR[row.dealStatus],
        }}
      />
    </Tooltip>
  </Box>
);
